import { RouterProvider } from 'react-router'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { AppProviders } from '@/providers/AppProviders'
import { router } from '@/router'

/**
 * The router is a **data router**, so it is created once at module scope and
 * handed to `RouterProvider` — which takes no children. The lazy screens'
 * Suspense boundary therefore lives inside the route tree, as a pathless layout
 * route (`SuspenseLayout` in `src/router/index.tsx`).
 *
 * The providers stay outside it: none of them uses a router hook, and keeping
 * them above the router means a navigation never remounts the query cache or
 * the auth session.
 */
export function App() {
  return (
    <ErrorBoundary scope="app">
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  )
}
